// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UFState } from 'uf/state';
import { getFlagHeaders } from 'uf/user/selectors/flags';

const DEFAULT_API_SERVER_ORIGIN = 'http://localhost:8080';
const API_SERVER_ORIGIN =
  process.env.UF_API_SERVER_ADDR || DEFAULT_API_SERVER_ORIGIN;

export const baseQuery = fetchBaseQuery({
  baseUrl: `${API_SERVER_ORIGIN}/api`,
  credentials: 'include',
  prepareHeaders: (headers, api) => {
    const state = api.getState();
    // Get toggled feature flags
    const flagHeaders = getFlagHeaders(state as UFState);
    headers.set('UF-Frontend-Version', __BUILD_INFO__.git_commit);
    headers.set('UF-Feature-Flags', flagHeaders['UF-Feature-Flags']);
  },
});

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery,
  endpoints: () => ({}),
  reducerPath: 'api-rtk',
});
